// all skill images
import azure_devops from "./images/skill_images/azure_devops_logo.jpeg";
import css from "./images/skill_images/css_logo.png";
import docker from "./images/skill_images/docker_logo.png";
import flask from "./images/skill_images/flask_logo.png";
import git from "./images/skill_images/git_logo.png";
import github from "./images/skill_images/github_logo.png";
import html from "./images/skill_images/html_logo.png";
import javascript from "./images/skill_images/javascript_logo.png";
import mongo from "./images/skill_images/mongodb_logo.png";
import python from "./images/skill_images/python_logo.png";
import react from "./images/skill_images/react_logo.png";
import vue from "./images/skill_images/vue_logo.png";
import claude from "./images/skill_images/claude_logo.png";

import slack from "./images/skill_images/slack_logo.png";
import trello from "./images/skill_images/trello_logo.png";
import typescript from "./images/skill_images/typescript_logo.png";
import vscode from "./images/skill_images/vscode.svg";
import pytorch from "./images/skill_images/pytorch_logo.png";
import numpy from "./images/skill_images/numpy_logo.png";
import pandas from "./images/skill_images/pandas_logo.png";

// all project images
// import primate_image_classifier from "./images/project_images/primate_image_classifier_screenshot.png";
// import form_generator from "./images/project_images/form_generator_screenshot.png";

import github_carousel from "./images/carousel_images/github_photo.png";
import catsearch from "./images/project_images/cat_search_screenshot.png";
import minesweeper from "./images/project_images/minesweeper_screenshot.png";
import octodex from "./images/project_images/octodex_screenshot.png";
import reddit from "./images/project_images/reddit_capstone_screenshot.png";
import spacex from "./images/project_images/spacex_screenshot.png";
import tetris_deluxe from "./images/project_images/tetris_screenshot.png";
import tictactoe from "./images/project_images/tic_tac_toe_screenshot.png";
import tv from "./images/project_images/tv_guide_screenshot.png";
import snake_game from "./images/project_images/snake_game_screenshot.png"

const images = {
  // skill images
  css,
  docker,
  flask,
  git,
  github,
  html,
  javascript,
  mongo,
  python,
  react,
  vue,
  slack,
  trello,
  typescript,
  vscode,
  azure_devops,
  pytorch,
  numpy,
  pandas,
  claude,

  github_carousel,
  // reddit,
  // spacex,
  // octodex,
  // minesweeper,
  // tv,
  // tictactoe,
  // tetris_deluxe,
  // catsearch,
  // snake_game
};

export default images;
